import { motion } from "framer-motion";

const LEVELS = ["Too short", "Weak", "Fair", "Strong", "Fortified"];

export function scorePassword(pw: string): number {
  if (pw.length < 6) return 0;
  let s = 1;
  if (pw.length >= 10) s++;
  if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) s++;
  if (/\d/.test(pw) && /[^A-Za-z0-9]/.test(pw)) s++;
  return s;
}

export function PasswordStrengthBar({ password }: { password: string }) {
  const score = password ? scorePassword(password) : -1;
  const t = Math.max(score, 0) / 4;
  const color = score <= 0 ? "#475569" : `color-mix(in srgb, #FF5B00 ${Math.round(t * 100)}%, #475569)`;

  return (
    <div data-testid="password-strength" className="flex flex-col gap-1.5 px-1">
      <div className="grid grid-cols-4 gap-1.5">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="h-[3px] overflow-hidden rounded-full bg-white/[0.06]">
            <motion.div
              className="h-full origin-left"
              initial={false}
              animate={{ scaleX: i < score ? 1 : 0, backgroundColor: color }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1], delay: i * 0.05 }}
            />
          </div>
        ))}
      </div>
      <div className="flex justify-between font-mono text-[10px] uppercase tracking-[0.18em]">
        <span className="text-cad">Strength</span>
        <motion.span
          key={score}
          data-testid="password-strength-label"
          initial={{ opacity: 0, y: 3 }}
          animate={{ opacity: 1, y: 0 }}
          style={{ color: score >= 3 ? "#FF5B00" : "#475569" }}
        >
          {score < 0 ? "—" : LEVELS[score]}
        </motion.span>
      </div>
    </div>
  );
}
